import Flickity from 'flickity';
import LazyLoad from 'vanilla-lazyload';

export default () => ({
    carousel: null,
    carouselTimeout: 12000,
    carouselRefreshInterval: null,
    buttons: [],

    init() {
        this.lazyLoadInstance = new LazyLoad({
            elements_selector: '.lazy',
            threshold: 0
        });

        this.carousel = new Flickity(this.$el.querySelector('.video-carousel-instance'), {
            autoPlay: this.carouselTimeout,
            draggable: true,
            adaptiveHeight: true,
            pageDots: false,
            pauseAutoPlayOnHover: false
        });

        this.setSlideDuration(this.carousel.selectedIndex);

        this.fadeInText();

        this.buttons = this.$el.querySelectorAll('.button');

        if (this.buttons.length > 0) {
            this.handleCarouselTimerButton();

            this.carousel.on('select', (index) => {
                this.carousel.stopPlayer();
                this.setSlideDuration(index);

                this.buttons.forEach((button, index) => {
                    if (index === this.carousel.selectedIndex) {
                        button.classList.add('active');
                        button.querySelector('circle').style.strokeDashoffset = '300px';
                    } else {
                        button.classList.remove('active');
                    }
                });

                this.carousel.playPlayer();
                this.handleCarouselTimerButton();
                this.pauseAllVideosExceptActive();
                this.fadeInText();
            });
        }
    },

    pauseAllVideosExceptActive() {
        this.lazyLoadInstance.update();

        if (!this.carousel) return;

        this.$el.querySelectorAll('video').forEach((video, index) => {
            if (video.closest('#plyr-wrapper'))
                return;

            if (index !== this.carousel.selectedIndex) {
                video.pause();
            } else {
                // Before playing the video, check if it has been loaded
                if (!video.src) {
                    video.src = video.dataset.src;
                    video.onloadeddata = function() {
                        video.play();
                    };
                } else {
                    video.currentTime = 0;
                    video.play();
                }
            }
        });
    },

    handleClick(index) {
        this.carousel.select(index);
        this.carousel.reposition();
    },

    handleCarouselTimerButton() {
        if (this.carouselRefreshInterval !== null) {
            clearInterval(this.carouselRefreshInterval);
        }

        let offset = 300;
        const intervalDuration = this.carouselTimeout / offset;

        this.carouselRefreshInterval = setInterval(() => {
            offset--;

            const currentButton = this.buttons[this.carousel.selectedIndex];
            if (!currentButton) return;

            const diamondWhiteBorder
                = currentButton.querySelector('.diamond-active-border');
            if (diamondWhiteBorder) {
                diamondWhiteBorder.style.strokeDashoffset = `${offset}px`;
            }

            if (offset <= 0) {
                clearInterval(this.carouselRefreshInterval);
                this.carouselRefreshInterval = null;
                this.carousel.next(true);
            }
        }, intervalDuration);
    },

    fadeInText() {
        this.$el.querySelectorAll('.carousel-meta').forEach((textSlide, index) => {
            const innerElements = textSlide.querySelectorAll('span');

            if (index === this.carousel.selectedIndex) {
                innerElements.forEach(element => element.classList.add('fade-up-and-in'));
            } else {
                innerElements.forEach(element => element.classList.remove('fade-up-and-in'));
            }
        });
    },

    setSlideDuration(index) {
        const selectedVideo = this.$el.querySelectorAll('video')[index];

        // convert the data attribute to a number and to milliseconds
        const videoDuration = Number(selectedVideo.dataset.videoDuration);

        this.carousel.options.autoPlay = videoDuration;
        this.carouselTimeout = videoDuration;
    }
});